import moment from 'moment';
import { request } from '~/components/Instance';

// Estado visual/urgência de uma tarefa da Conferência:
// - done: todos os clientes avisados
// - siren: vencimento a <=1 dia (ou recém vencido) com clientes pendentes
// - overdue: prazo passou há mais de 5 dias e ainda há clientes sem aviso
// - normal: dentro do mês, ainda há tempo
export const getCardState = (task) => {
  const due = moment(task.due_date, 'YYYY-MM-DD');
  const daysToDue = due.diff(moment().startOf('day'), 'days');

  if (task.pending === 0) return 'done';
  if (daysToDue <= 1 && daysToDue >= -5) return 'siren';
  if (daysToDue < -5) return 'overdue';
  return 'normal';
};

export const STATE_PRIORITY = { siren: 0, overdue: 1, normal: 2, done: 3 };

const CACHE_TTL = 3 * 60 * 1000;
let summaryCache = { at: 0, promise: null };

// Resumo do mês corrente da Conferência (com cache de alguns minutos),
// usado pelo widget do dashboard e pelo dot do menu.
export const fetchConferenceSummary = (force) => {
  const now = Date.now();

  if (!force && summaryCache.promise && now - summaryCache.at < CACHE_TTL) {
    return summaryCache.promise;
  }

  const promise = request('get', `/conference/tasks/${moment().format('YYYY-MM')}`, {}, false)
    .then((response) => {
      const tasks = (response.data && response.data.data) || [];

      let sirenPending = 0;
      let sirenTasks = 0;
      let pending = 0;
      let late = 0;

      tasks.forEach((task) => {
        const state = getCardState(task);
        pending += task.pending;
        late += task.notified_late;
        if (state === 'siren') {
          sirenTasks += 1;
          sirenPending += task.pending;
        }
      });

      return { tasks, sirenTasks, sirenPending, pending, late };
    })
    .catch(() => {
      summaryCache = { at: 0, promise: null };
      return { tasks: [], sirenTasks: 0, sirenPending: 0, pending: 0, late: 0 };
    });

  summaryCache = { at: now, promise };
  return promise;
};
